// Marking an invoice uncollectible only books its open balance to bad debt
// expense for USD invoices — the backend JE builder skips journal-entry
// generation entirely for non-USD invoices
// (journal-entries-builder.service.ts). Confirmation copy must not promise a
// bad-debt booking (or a USD amount) for non-USD invoices.
export const invoiceBooksToBadDebt = (currency: string): boolean =>
    currency.toLowerCase() === "usd";
